hrd.charts.AreaChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions);
	},
	doChart: function(dynamicOptions){
		this._super(dynamicOptions);
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.line = {
			connectNull: dynamicOptions.connectNull
		};
		staticOptions.area = {
			zerobased: dynamicOptions.zerobased
		};
	}
});